<template>
    <div>
        <div class="container-fluid mt-2 mb-5">
            <div class="row">
                <div class="col-md-12">
                    <h3><span class="material-icons md-24 text-main-gradient">assessment</span> Reportes</h3>
                </div>
                <div class="col-md-12 mt-3">
                    <p>
                        Aquí puedes ver un listado completo de todos tus pacientes y consultas registradas. Utiliza la paginación para navegar entre los registros.
                    </p>
                </div>

                <!-- Sección de Pacientes -->
                <div class="col-md-12 mt-4 mb-4">
                    <h4>Listado de Pacientes (Total: {{ totalPatients }})</h4>
                    <div class="table-responsive">
                        <vs-table class="custom-table">
                            <template #thead>
                                <vs-tr>
                                    <vs-th>Nombre</vs-th>
                                    <vs-th>Fecha de Nacimiento</vs-th>
                                    <vs-th>Teléfono</vs-th>
                                    <vs-th>Email</vs-th>
                                    <vs-th>Registrado el</vs-th>
                                </vs-tr>
                            </template>
                            <template #tbody>
                                <vs-tr :key="paciente.id" v-for="paciente in pacientes" :data="paciente">
                                    <vs-td>{{ paciente.nombre }}</vs-td>
                                    <vs-td>{{ formatDate(paciente.fecha_nacimiento) }}</vs-td>
                                    <vs-td>{{ paciente.telefono || 'N/A' }}</vs-td>
                                    <vs-td>{{ paciente.email || 'N/A' }}</vs-td>
                                    <vs-td>{{ formatDateTime(paciente.creado_en) }}</vs-td>
                                </vs-tr>
                                <vs-tr v-if="pacientes.length === 0">
                                    <vs-td colspan="5" class="text-center">No se encontraron pacientes.</vs-td>
                                </vs-tr>
                            </template>
                        </vs-table>
                    </div>
                    <v-pagination v-if="totalPages > 1" v-model="currentPage" :page-count="totalPages" @input="fetchPacientes" />
                </div>

                <!-- Nueva Sección de Consultas -->
                <div class="col-md-12 mt-5 mb-4">
                    <h4>Listado de Consultas (Total: {{ totalConsultas }})</h4>
                    <div class="table-responsive">
                        <vs-table class="custom-table">
                            <template #thead>
                                <vs-tr>
                                    <vs-th>Paciente</vs-th>
                                    <vs-th>Motivo</vs-th>
                                    <vs-th>Tipo Consulta</vs-th>
                                    <vs-th>Inicio Cita</vs-th>
                                    <vs-th>Fin Cita</vs-th>
                                    <vs-th>Estatus</vs-th>
                                    <vs-th>Origen</vs-th>
                                    <vs-th>Registrada el</vs-th>
                                </vs-tr>
                            </template>
                            <template #tbody>
                                <vs-tr :key="consulta.id" v-for="consulta in consultas" :data="consulta">
                                    <vs-td>{{ consulta.nombre_paciente }}</vs-td>
                                    <vs-td>{{ consulta.motivo }}</vs-td>
                                    <vs-td>{{ consulta.tipo_consulta }}</vs-td>
                                    <vs-td>{{ formatDateTime(consulta.inicio_cita) }}</vs-td>
                                    <vs-td>{{ formatDateTime(consulta.fin_cita) }}</vs-td>
                                    <vs-td>{{ consulta.estatus_cita }}</vs-td>
                                    <vs-td>{{ consulta.origen }}</vs-td>
                                    <vs-td>{{ formatDateTime(consulta.creado_en) }}</vs-td>
                                </vs-tr>
                                <vs-tr v-if="consultas.length === 0">
                                    <vs-td colspan="8" class="text-center">No se encontraron consultas.</vs-td>
                                </vs-tr>
                            </template>
                        </vs-table>
                    </div>
                    <v-pagination v-if="totalConsultasPages > 1" v-model="currentConsultasPage" :page-count="totalConsultasPages" @input="fetchConsultas" />
                </div>

                <!-- Nueva Sección de Auditorías -->
                <div class="col-md-12 mt-5 mb-4">
                    <h4>Registro de Auditoría (Total: {{ totalAuditorias }})</h4>
                    <div class="table-responsive">
                        <vs-table class="custom-table">
                            <template #thead>
                                <vs-tr>
                                    <vs-th>Acción</vs-th>
                                    <vs-th>Detalles</vs-th>
                                    <vs-th>Fecha</vs-th>
                                    <!-- <vs-th>Usuario</vs-th>  // Comentado ya que filtra por el usuario actual -->
                                </vs-tr>
                            </template>
                            <template #tbody>
                                <vs-tr :key="audit.id" v-for="audit in auditorias" :data="audit">
                                    <vs-td>{{ audit.accion }}</vs-td>
                                    <vs-td>{{ audit.detalles }}</vs-td>
                                    <vs-td>{{ formatDateTime(audit.fecha) }}</vs-td>
                                    <!-- <vs-td>{{ audit.usuario }}</vs-td> -->
                                </vs-tr>
                                <vs-tr v-if="auditorias.length === 0">
                                    <vs-td colspan="6" class="text-center">No se encontraron registros de auditoría.</vs-td>
                                </vs-tr>
                            </template>
                        </vs-table>
                    </div>
                    <v-pagination v-if="totalAuditoriaPages > 1" v-model="currentAuditoriaPage" :page-count="totalAuditoriaPages" @input="fetchAuditorias" />
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import vPagination from 'vue-plain-pagination';
    var config = require("@/config/api.json");
    const API = config.api;

    export default {
        name: "Reportes",
        components: {
            vPagination
        },
        data() {
            return {
                currentUser: null,
                // Datos de Pacientes
                pacientes: [],
                currentPage: 1,
                totalPages: 1,
                totalPatients: 0,
                // Datos de Consultas
                consultas: [],
                currentConsultasPage: 1,
                totalConsultasPages: 1,
                totalConsultas: 0,
                // Datos de Auditorías
                auditorias: [],
                currentAuditoriaPage: 1, // Página actual para auditorías
                totalAuditoriaPages: 1, // Total de páginas para auditorías
                totalAuditorias: 0 // Total de registros de auditoría
            };
        },
        mounted() {
            try {
                const user = JSON.parse(localStorage.getItem('user'));
                if (user) {
                    this.currentUser = user;
                    this.fetchPacientes();
                    this.fetchConsultas();
                    this.fetchAuditorias(); // Carga inicial de auditorías
                } else {
                    this.notify('error', 'Usuario no autenticado. No se pueden cargar los reportes.');
                }
            } catch (error) {
                console.error('Error loading user from localStorage:', error);
                this.notify('error', 'Error al cargar la información del usuario.');
            }
        },
        methods: {
            async fetchPacientes(page = 1) {
                if (!this.currentUser?.mainId) {
                    this.notify('error', 'No se pudo obtener el ID del médico.');
                    return;
                }
                try {
                    const response = await axios.get(`${API}/todosLosPacientes`, {
                        params: {
                            personal_medico_id: this.currentUser.mainId,
                            page: page
                        }
                    });

                    if (response.data.status === 'success') {
                        this.pacientes = response.data.data;
                        this.currentPage = response.data.currentPage;
                        this.totalPages = response.data.totalPages;
                        this.totalPatients = response.data.totalPatients;
                    } else {
                        this.notify('error', `Error al obtener los pacientes: ${response.data.message}`);
                    }
                } catch (error) {
                    console.error('Error al obtener los pacientes:', error);
                    this.notify('error', `Error de conexión o del servidor: ${error.message}`);
                }
            },
            async fetchConsultas(page = 1) {
                if (!this.currentUser?.mainId) {
                    this.notify('error', 'No se pudo obtener el ID del médico para cargar consultas.');
                    return;
                }
                try {
                    const response = await axios.get(`${API}/pacienteConsultas`, {
                        params: {
                            personal_medico_id: this.currentUser.mainId,
                            page: page
                        }
                    });

                    if (response.data.status === 'success') {
                        this.consultas = response.data.data;
                        this.currentConsultasPage = response.data.currentPage;
                        this.totalConsultasPages = response.data.totalPages;
                        this.totalConsultas = response.data.totalConsultas;
                    } else {
                        this.notify('error', `Error al obtener las consultas: ${response.data.message}`);
                    }
                } catch (error) {
                    console.error('Error al obtener las consultas:', error);
                    this.notify('error', `Error de conexión o del servidor al obtener consultas: ${error.message}`);
                }
            },
            async fetchAuditorias(page = 1) {
                if (!this.currentUser?.mainId) {
                    this.notify('error', 'No se pudo obtener el ID del médico para cargar auditorías.');
                    return;
                }
                try {
                    const response = await axios.get(`${API}/solicitaAuditorias`, {
                        params: {
                            personal_medico_id: this.currentUser.mainId,
                            page: page
                        }
                    });

                    if (response.data.status === 'success') {
                        this.auditorias = response.data.data;
                        this.currentAuditoriaPage = response.data.currentPage;
                        this.totalAuditoriaPages = response.data.totalPages;
                        this.totalAuditorias = response.data.totalAuditorias; // Asegúrate que el backend devuelva 'totalAuditorias'
                    } else {
                        this.notify('error', `Error al obtener las auditorías: ${response.data.message}`);
                    }
                } catch (error) {
                    console.error('Error al obtener las auditorías:', error);
                    this.notify('error', `Error de conexión o del servidor al obtener auditorías: ${error.message}`);
                }
            },
            formatDate(dateString) {
                if (!dateString) return 'N/A';
                const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
                return new Date(dateString).toLocaleDateString('es-MX', options);
            },
            formatDateTime(dateTimeString) {
                if (!dateTimeString) return 'N/A';
                const options = { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' };
                return new Date(dateTimeString).toLocaleString('es-MX', options);
            },
            // Asumiendo que tienes un método global o mixin para notificaciones
            // Si no, puedes implementar uno básico aquí o importarlo.
            notify(type, message) {
                // Implementación básica de notificación (puedes usar Vuesax notifications o similar)
                console.log(`[${type.toUpperCase()}] ${message}`);
                this.$vs.notification({
                    color: type === 'error' ? 'danger' : type, // success, warning, danger, primary
                    title: type === 'error' ? 'Error' : 'Notificación',
                    text: message
                });
            }
        }
    };
</script>

<style scoped>
/* Estilos específicos para Reportes.vue si son necesarios */
.custom-table {
    /* Puedes añadir estilos personalizados para la tabla aquí si es necesario */
}
.material-icons.md-24 {
    vertical-align: middle; /* Alinea el icono verticalmente */
}
.text-main-gradient {
    /* Asegúrate de que esta clase exista globalmente o defínela aquí */
    background: linear-gradient(to right, #3fadee, #22a7f0); /* Ejemplo de gradiente */
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
}
</style>
